import { css, Theme } from '@emotion/react'

export const wrapper = css`
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  width: 100%;
  padding: 80px 40px 120px;
`

export const icon = css`
  max-width: 100%;
  height: auto;
`

export const title = (theme: Theme) =>
  css`
    color: ${theme.colors.typographyOne};
    text-align: center;
    font-feature-settings: 'clig' off, 'liga' off;
    font-size: 54px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    margin: 35px 0 12px;
    max-width: 604px;
  `

export const description = (theme: Theme) =>
  css`
    color: ${theme.colors.typographyTwo};
    text-align: center;
    font-feature-settings: 'clig' off, 'liga' off;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 30px;
    max-width: 620px;
  `
